// organize-imports-ignore
import "@homebound/activesupport";
import "src/globalThis";
import { ApolloProvider } from "@apollo/client";
import { configureAuth } from "@homebound/auth-components";
import { AnimatePresence } from "framer-motion";
import { OverlayProvider } from "react-aria";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import "react-tooltip/dist/react-tooltip.css";
import { CssReset } from "~components";
import App from "./App";
import { createApolloClient, getGoogleClientId, getStage, initialAmplifyConfig } from "./context";
import { FeatureFlagProvider, ModalProvider, PageVisibilityProvider, ViewportProvider } from "./contexts";
import { configure } from "mobx";
import { enableAnalytics } from "./utils/analytics";
import { PostHogProviderWrapper } from "./utils/PostHogProviderWrapper";

import { initializeDebugMode } from "./utils/debugMode";
import { GoogleOAuthProvider } from "@react-oauth/google";
// import { Amplify } from "@aws-amplify/core";
// Amplify.Logger.LOG_LEVEL = "DEBUG";

// formState doesn't use actions
configure({ enforceActions: "never" });

const stage = getStage();
const apolloClient = createApolloClient(stage);
// Get Google OAuth Client ID from config (for homeowner auth pool)
const googleClientId = getGoogleClientId(stage);

configureAuth(initialAmplifyConfig(), {
  signInFailureHandler: (errorMessage) => {
    // This handler fires during OAuth callback flows (e.g., at /auth/gcallback) when
    // Google auth succeeds but Cognito rejects the user (not in user pool).
    console.error("Sign in failure:", errorMessage);
    // Only redirect if we're not already on the sign-in page (to avoid interfering with magic link flows).
    // Without this guard, magic link auth failures would cause redirect loops.
    if (!window.location.pathname.startsWith("/signIn")) {
      window.location.assign("/signIn?signInError=true");
    }
  },
});
void enableAnalytics(stage);
initializeDebugMode();

const root = createRoot(document.getElementById("root")!);
root.render(
  // We purposely do not use StrictMode because it breaks useComputed.
  // Providers
  <GoogleOAuthProvider clientId={googleClientId}>
    <ApolloProvider client={apolloClient}>
      {/* Moved AnimatePresence here from Animated Route component as it was causing rendering issues */}
      <AnimatePresence mode="wait">
        <HelmetProvider>
          <BrowserRouter>
            <FeatureFlagProvider>
              <PageVisibilityProvider>
                <ViewportProvider>
                  <OverlayProvider>
                    <ModalProvider>
                      <CssReset />
                      <PostHogProviderWrapper>
                        <App />
                      </PostHogProviderWrapper>
                    </ModalProvider>
                  </OverlayProvider>
                </ViewportProvider>
              </PageVisibilityProvider>
            </FeatureFlagProvider>
          </BrowserRouter>
        </HelmetProvider>
      </AnimatePresence>
    </ApolloProvider>
  </GoogleOAuthProvider>,
);
